import { Outlet } from 'react-router-dom'

export default function EmptyLayout({ children }) {
  return (
    <div>
      <Outlet />
    </div>
  )
}
